import { FeatureFlagOptions } from "../../../core/feature-flags/feature-flag-options";
import templateUrl from "./feature-toggle.component.html";

/**
 * A component managing the options for opting in or out of a feature.
 */
export const FeatureToggleComponent = {
    templateUrl,
    bindings: {
        feature: "@",
        title: "@",
        description: "@",
        autoReloadOnToggle: "<?",
        toggle: "&onToggle",
        hide: "&onHide"
    },
    controller: class {
        constructor($state, featureManager) {
            'ngInject';
            this.featureManager = featureManager;
            this.$state = $state;
            this.FeatureFlagOptions = FeatureFlagOptions;
        }

        $onChanges(changesObj) {
            this.option = this.featureManager.getFeatureFlagOption(this.feature);
            // If the flag is forcibly enabled or disabled, do not present any options to toggle.
            this.canToggle = this.option !== FeatureFlagOptions.enabled
                && this.option !== FeatureFlagOptions.disabled;
        }

        onToggle(option) {
            if (this.option !== option) {
                if (option === FeatureFlagOptions.optIn) {
                    this.featureManager.saveFeatureFlagOption(true)
                        .then(() => {
                            console.log("Opt In");
                        })
                    this.featureManager.optIn(this.feature);
                } else if (option === FeatureFlagOptions.optOut) {
                    this.featureManager.saveFeatureFlagOption(false)
                        .then(() => {
                            console.log("Opt Out");
                        });
                    this.featureManager.optOut(this.feature);
                }
                this.togglePayrollEntry(option);
            }
        }

        togglePayrollEntry(option) {
            if (this.autoReloadOnToggle && this.option !== FeatureFlagOptions.noPref) {
                this.option = option;
                this.$state.reload();
            } else {
                this.option = option;
                this.toggle({
                    $event: {
                        feature: this.feature,
                        option: this.option
                    }
                });
            }
        }
    }
}
